import styled from "styled-components/macro";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import {
  PaymentElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import "../styles/Checkout.css";
import { isEmpty } from "../functions/isEmpty";
import { MdArrowBackIosNew, MdArrowForwardIos, MdMenu } from "react-icons/md";
import { getEuroCentToEuro } from "../functions/getEuroCentToEuro";

export default function StripeCheckoutForm({
  apiURL,
  isMobile,
  authToken,
  order,
  setReload,
  reload,
  setActiveOrderRedirect,
  companyData,
  orderData,
  setOrderData,
  payment_id,
}) {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const placeOrder = async () => {
    setIsLoading(true);
    if (!isLoading) {
      let now = Math.floor(Date.now() / 1000);

      let companyname = document.getElementById("companyname").value;
      let firstname = document.getElementById("firstname").value;
      let lastname = document.getElementById("lastname").value;
      let streetname = document.getElementById("streetname").value;
      let streetnumber = document.getElementById("streetnumber").value;
      let zip = document.getElementById("zip").value;
      let city = document.getElementById("city").value;

      const resa = await fetch(`${apiURL}/api/orders/index.php`, {
        method: "PUT",
        headers: {
          //   Authorization: `Bearer ${authToken?.JWT}`,
          "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        body: JSON.stringify({
          buyer_id: companyData.id,
          buyer_name: companyData.companyname,
          buyer_pic: orderData.buyer_pic,

          buyer_companyname: companyname,
          buyer_firstname: firstname,
          buyer_lastname: lastname,
          buyer_streetname: streetname,
          buyer_streetnumber: streetnumber,
          buyer_zip: zip,
          buyer_city: city,

          seller_id: orderData.seller_id,
          seller_name: orderData.seller_name,
          seller_pic: orderData.seller_pic,
          seller_price: orderData.seller_price,

          input_pic: isEmpty(orderData.input_pic)
            ? "https://www.developercloud.letsfluence.com/api/images/placeholder/profilbildplaceholder.jpg"
            : orderData.input_pic,
          input_companyname: orderData.input_companyname,
          input_companywebsite: orderData.input_companywebsite,
          input_companycolor: orderData.input_companycolor,
          input_companyphone: orderData.input_companyphone,
          input_exposeTitle: orderData.input_exposeTitle,
          input_exposeDescription: orderData.input_exposeDescription,

          service_id: orderData.service_id,
          service_template_schema_id: orderData.service_template_schema_id,
          service_title: orderData.service_title,
          service_video_url: orderData.service_video_url,
          service_img_url: orderData.service_img_url,

          payment_id: payment_id,

          createdAt: now,
        }),
      });

      await resa.text().then((value) => handleSubmit());
    }
  };

  const handleSubmit = async (e) => {
    setIsLoading(true);

    if (!stripe || !elements) {
      setErrorMessage("Stripe ist noch nicht geladen.");
      setIsLoading(false);
      return;
    }

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/orders?success`,
      },
    });

    if (error) {
      setErrorMessage(error.message);
    } else {
      setReload(!reload);
    }
    setIsLoading(false);
  };

  return (
    <div className="">
      {isMobile ? (
        <div className="checkout_topnav">
          <div
            className="checkout_topnav_back"
            onClick={() => navigate("/product/" + orderData.service_id)}>
            <ArrowBack />
          </div>
          <div
            className=""
            onClick={() => navigate("/product/" + orderData.service_id)}>
            Beauftragen
          </div>
        </div>
      ) : (
        <div className="checkout_topnav">
          <div
            className="checkout_topnav_left_title"
            onClick={() => navigate("/product/" + orderData.service_id)}>
            <ArrowBackDesktop />
            Beauftragen
          </div>
        </div>
      )}
      <div className="checkout_body">
        <div className="checkout_body_section">
          <div className="checkout_body_section_title">Buchungsdaten</div>
          <div className="checkout_body_section_inputboxfull">
            <input
              className="checkout_body_section_inputboxfull_input"
              placeholder="Firmenname (optional)"
              id={"companyname"}
            />
          </div>
          <div className="checkout_body_section_inputboxhalf">
            <input
              className="checkout_body_section_inputboxhalf_input"
              placeholder="Vorname"
              id={"firstname"}
            />
            <input
              className="checkout_body_section_inputboxhalf_input"
              placeholder="Nachname"
              id={"lastname"}
            />
          </div>
          <div className="checkout_body_section_inputboxhalf">
            <input
              className="checkout_body_section_inputboxhalf_input"
              placeholder="Straße"
              id={"streetname"}
            />
            <input
              className="checkout_body_section_inputboxhalf_input"
              placeholder="Hausnummer"
              id={"streetnumber"}
            />
          </div>
          <div className="checkout_body_section_inputboxhalf">
            <input
              className="checkout_body_section_inputboxhalf_input"
              placeholder="Postleitzahl"
              id={"zip"}
            />
            <input
              className="checkout_body_section_inputboxhalf_input"
              placeholder="Stadt"
              id={"city"}
            />
          </div>
        </div>
        <div className="checkout_body_section">
          <div className="checkout_body_section_title">Zahlungsdaten</div>
          <div
            className=""
            style={{
              paddingLeft: "14px",
              paddingRight: "14px",
              paddingTop: "4px",
            }}>
            <PaymentElement />
          </div>
        </div>
        <div className="checkout_body_section actionbar">
          <div className="checkout_body_section_title">Deine Bestellung</div>
          <div className="checkout_body_section_order">
            <div className="checkout_body_section_order_left">
              <img
                src={!isEmpty(orderData) ? order.service_img_url : ""}
                className="checkout_body_section_order_left_img"
              />
            </div>
            <div className="checkout_body_section_order_right">
              <div className="" style={{ fontWeight: "500" }}>
                {" "}
                {!isEmpty(orderData) && orderData.service_title}{" "}
              </div>
              {!isEmpty(orderData) && orderData.seller_name}
              <br />
              {!isEmpty(orderData) && getEuroCentToEuro(orderData.seller_price)}
              <br />
            </div>
          </div>
          <div className="checkout_body_section_ctatext">
            Mit diener Bestellung akzeptierst du die AGB und
            Nutzungsbestimmungen
          </div>

          {!stripe || isLoading ? (
            <div className="checkout_body_section_cta">Lädt</div>
          ) : (
            <div
              className="checkout_body_section_cta"
              onClick={() => placeOrder()}>
              Jetzt bezahlen
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const ArrowBackDesktop = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
  margin-bottom: -5px;
  margin-right: 5px;
`;
